"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var manage_filters_button_html_1 = __importDefault(require("./manage-filters-button.html"));
var context_meta_1 = require("@shared/types/context-meta");
var filter_utils_1 = require("@shared/utils/filter-utils");
(function (module) {
    'use strict';
    var ManageFiltersButtonController = function ($filter, $scope, Filters, prFilterUtils, setPRFilters, prMetricsService, prFilterLevels, activeReport) {
        var translate = $filter('translate');
        var self = this;
        self.$onInit = function () {
            _.merge(self, _.pick($scope, ['setFilters', 'filters', 'sourceIds', 'widgetLevel', 'metricIndex']));
            self.$scope = $scope;
            self.metricsService = prMetricsService;
            self.filterLevels = prFilterLevels;
            // only call init when filter is widget level or metric level and is from current metric in view
            if (self.widgetLevel || (self.metricLevel && self.metricIndex && (self.metricIndex === self.currentMetricIndex)) || self.isBreakoutByFilters) {
                self.init().then(function (filtersMenuItems) {
                    self.cleanUpDeletedFilters(filtersMenuItems);
                });
            }
        };
        self.$onChanges = function (changes) {
            // monitor changes, if sourceIds or currentMetricIndex is changed, init component
            var currentMetricIndex = changes.currentMetricIndex;
            var currentSourceIds = changes.sourceIds;
            if (self.metricLevel && currentMetricIndex
                && !_.isUndefined(currentMetricIndex.currentValue)
                && _.isEqual(currentMetricIndex.currentValue, self.metricIndex)) {
                return self.init();
            }
            if (currentSourceIds && !currentSourceIds.isFirstChange()
                && !_.isEqual(currentSourceIds.currentValue, currentSourceIds.previousValue)) {
                return self.init();
            }
        };
        self.init = function () {
            self.waitForInit = true;
            self.hasSavedFilters = false;
            self.sourceDefs = {};
            self.sourceFilter = _.cloneDeep((self.filters || {})[self.sourceIds[0]] || {});
            self.filterService = new Filters(self.sourceIds[0], self.sourceFilter, setPRFilters.setPRFilters(self, false));
            if (!_.isEmpty(self.sourceFilter)) {
                // Fix old PR date filters
                prFilterUtils.fixDateFilters(self.sourceFilter);
                filter_utils_1.fixOldPRFilters(self.sourceFilter);
            }
            self.getBtnClass = function () {
                if (self.widgetLevel || self.metricLevel) {
                    if (self.hasFilterApplied) {
                        return { 'btn btn-sm': true, 'toggle-single-metric-breakout-btn': self.isBreakoutByFilters };
                    }
                    else {
                        return 'btn btn-full';
                    }
                }
                return 'btn btn-sm btn-hover';
            };
            self.getFilterLabel = function () {
                if (self.hasFilterApplied) {
                    var filterLabel = self.filterService.getTruncatedFilterName() || translate('NEW_FILTER');
                    if (self.isBreakoutByFilters) {
                        // The current instance of filterService may not be attached
                        // to the correct filter when we have breakoutByFilters because
                        // filterService is a singleton that is shared by many filters.
                        // In this case, filterService returns the wrong filterName.
                        filterLabel = self.getCorrectedLabel() || filterLabel;
                    }
                    return filterLabel;
                }
                if (self.hasSavedFilters) {
                    return translate('ADD_FILTER');
                }
                else {
                    return translate('ADD_FILTER_ELLIPSIS');
                }
            };
            self.getCorrectedLabel = function () {
                var sourceId = self.sourceIds[0];
                var isCurrFilterSet = self.filters && self.filters[sourceId] && self.filters[sourceId].name;
                if (isCurrFilterSet) {
                    var filterMeta = self.filterService.getFilterMeta();
                    var currFilter = self.filters[sourceId];
                    var isSameFilterId = filterMeta.filterId === currFilter.filterId;
                    if (isSameFilterId) {
                        self.savedCorrectFiltersLabel = filterMeta.name;
                    }
                    var maxLengthObj = { length: Filters.MAX_FILTER_NAME_LENGTH };
                    return (_.truncate(self.savedCorrectFiltersLabel, maxLengthObj) ||
                        _.truncate(currFilter.name, maxLengthObj));
                }
                return '';
            };
            self.getFilterLabelTooltip = function () {
                if (self.isBreakoutByFilters && self.savedCorrectFiltersLabel) {
                    return self.savedCorrectFiltersLabel;
                }
                return self.filterService.getFilterName();
            };
            self.isFilterNameTruncated = function () {
                if (self.isBreakoutByFilters && self.savedCorrectFiltersLabel) {
                    return self.savedCorrectFiltersLabel.length > Filters.MAX_FILTER_NAME_LENGTH;
                }
                return self.hasFilterApplied && self.filterService.isFilterNameTruncated();
            };
            self.canFilter = function () {
                return self.filterService.canFilter();
            };
            return self.filterService.init()
                .then(function () {
                return self.filterService.hasSavedFilters();
            })
                .then(function (hasSavedFilters) {
                self.hasSavedFilters = hasSavedFilters;
                self.hasFilterApplied = (self.filterService.hasValidFilterApplied() || self.filterService.isValidFilter(self.sourceFilter));
                self.waitForInit = false;
                return self.filterService.getFiltersMenu();
            });
        };
        // https://qualtrics.atlassian.net/browse/REP-8087
        // TODO: we should not clean up deleted filters here
        // Deleted filters should be removed from the data config
        // in the widget preprocessors when they first load
        self.cleanUpDeletedFilters = function (filtersMenuItems) {
            var _a, _b;
            var filterId = self.sourceFilter.filterId;
            var filterFound = !!_.find(filtersMenuItems, function (filter) {
                return _.get(filter, 'value.id') === filterId;
            });
            if (filterFound) {
                return;
            }
            var reportImport = activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.REPORT_IMPORT);
            var unregisteredFilters = (_b = (_a = reportImport === null || reportImport === void 0 ? void 0 : reportImport.importContext) === null || _a === void 0 ? void 0 : _a.unregisteredFilters) !== null && _b !== void 0 ? _b : [];
            if (!unregisteredFilters.includes(filterId)) {
                self.removeAppliedFilter();
            }
        };
        self.getFilterType = function () {
            if (self.widgetLevel) {
                return prFilterLevels.WIDGET_LEVEL;
            }
            else if (self.metricLevel) {
                return prFilterLevels.METRIC_LEVEL;
            }
            else {
                return prFilterLevels.REPORT_LEVEL;
            }
        };
    };
    ManageFiltersButtonController.prototype.getFiltersMenu = function () {
        return this.filterService.getFiltersMenu();
    };
    ManageFiltersButtonController.prototype.openManageFiltersModal = function () {
        if (this.isBreakoutByFilters) {
            var self_1 = this;
            return this.filterService.init().then(function () {
                return self_1.filterService.openManageFiltersModal();
            });
        }
        return this.filterService.openManageFiltersModal();
    };
    ManageFiltersButtonController.prototype.removeAppliedFilter = function () {
        var type = this.getFilterType();
        this.metricsService.setFilter(this.hasFilterApplied, null, type);
        if (this.isBreakoutByFilters) {
            return this.deleteBreakoutFilter();
        }
        return this.filterService.removeFilter();
    };
    ManageFiltersButtonController.prototype.selectFilterMenuItem = function (selectedMenuItem) {
        var self = this;
        var type = this.getFilterType();
        return this.init().then(function () {
            self.metricsService.setFilter(null, selectedMenuItem, type);
            return self.filterService.selectFilterMenuItem(selectedMenuItem);
        });
    };
    ManageFiltersButtonController.$inject = [
        '$filter',
        '$scope',
        'prFilterService',
        'prFilterUtils',
        'prSetPRFiltersFactory',
        'prMetricsService',
        'pr.FILTER_LEVELS',
        'prActiveReport'
    ];
    module.controller('manageFiltersButtonController', ManageFiltersButtonController);
    module.component('prManageFiltersButton', {
        templateUrl: manage_filters_button_html_1.default,
        controller: 'manageFiltersButtonController as $ctrl',
        bindings: {
            filters: '<',
            setFilters: '&',
            sourceIds: '<',
            widgetLevel: '<',
            metricLevel: '<',
            metricIndex: '<',
            currentMetricIndex: '<',
            // should be used to display multiple breakout filters
            isBreakoutByFilters: '<',
            deleteBreakoutFilter: '&',
        }
    });
})(angular.module('qualtrics.pr'));
